<div fxLayout="row">
    <span>{{ 'agent_panel_settings.inbound'|translate }}</span>
    <mat-slide-toggle [(ngModel)]="autoLaunchEnable" (ionChange)="changeAutoLaunchState()" color="positive"></mat-slide-toggle>
</div>
<div fxLayout="row">
    <span>{{ 'agent_panel_settings.campaign'|translate }}</span>
    <mat-slide-toggle [(ngModel)]="autoLaunchEnable" (ionChange)="changeAutoLaunchState()" color="positive"></mat-slide-toggle>
</div>
